import { required, email, minLength } from 'vuelidate/lib/validators';
import sesionService from '@/services/SesionService.js';

export default {
	name: 'Login',
	components: {},
	props: [],
	data() {
		return {
			errors: [],
			show: false,
			usuario: '',
			password: '', //"12345678",
			submitted: false,
			msjErrorlogin: ''
		};
	},
	created() {
		if (sesionService.isAuthenticated()) sesionService.redirectHome();
	},
	validations: {
		usuario: {
			required,
			email
		},
		password: {
			required,
			minLength: minLength(7)
		}
	},
	methods: {
		onSubmit(event) {
			this.submitted = true;
			this.$v.$touch();
			if (!this.$v.$invalid) {
				var login = {
					email: this.usuario,
					password: this.password
				};

				this.$store.dispatch('login', login).then((response) => {
					if (response.Code != 200) {

						this.msjErrorlogin = response.Message;
						this.$mixpanel.track('Failed login', {
							message: response.Message
						});
					} else {

						this.$mixpanel.track('Succesful login', {
							message: this.usuario
						});
						this.$mixpanel.identify(this.usuario);
					}
				});
			}

			event.preventDefault();
		},
		fadeMe: function () {
			this.show = !this.show;
		}
	}
};
